import { useMemo } from "react";
import { ESupportTicketProduct } from "@devowl-wp/api-real-commerce";
import { __ } from "../utils/i18n.js";
/**
 * Get the product type localized as object.
 */ function useSupportFormProductType() {
    return useMemo(()=>{
        const result = {};
        Object.keys(ESupportTicketProduct).forEach((key)=>{
            const value = ESupportTicketProduct[key];
            let knowledgeBaseTopics;
            switch(value){
                case ESupportTicketProduct.RealCookieBanner:
                    knowledgeBaseTopics = [
                        "real-cookie-banner",
                        "wordpress",
                        "legal"
                    ];
                    break;
                case ESupportTicketProduct.RealCategoryManagement:
                    knowledgeBaseTopics = [
                        "real-category-management",
                        "wordpress",
                        "legal"
                    ];
                    break;
                case ESupportTicketProduct.RealMediaLibrary:
                    knowledgeBaseTopics = [
                        "real-media-library",
                        "wordpress",
                        "legal"
                    ];
                    break;
                case ESupportTicketProduct.RealPhysicalMedia:
                    knowledgeBaseTopics = [
                        "real-physical-media",
                        "wordpress",
                        "legal"
                    ];
                    break;
                case ESupportTicketProduct.RealThumbnailGenerator:
                    knowledgeBaseTopics = [
                        "real-thumbnail-generator",
                        "wordpress",
                        "legal"
                    ];
                    break;
                default:
                    break;
            }
            let ecommercePlatform;
            switch(value){
                case ESupportTicketProduct.RealCookieBanner:
                    ecommercePlatform = "self-hosted";
                    break;
                case ESupportTicketProduct.RealCategoryManagement:
                case ESupportTicketProduct.RealMediaLibrary:
                case ESupportTicketProduct.RealPhysicalMedia:
                case ESupportTicketProduct.RealThumbnailGenerator:
                    ecommercePlatform = "envato";
                    break;
                default:
                    break;
            }
            let licenseHelpArticle;
            switch(ecommercePlatform){
                case "self-hosted":
                    licenseHelpArticle = __("https://devowl.io/knowledge-base/devowl-where-can-i-find-my-license-key/");
                    break;
                case "envato":
                    licenseHelpArticle = __("https://devowl.io/knowledge-base/codecanyon-where-can-i-find-my-license-key/");
                    break;
                default:
                    break;
            }
            let localized = key;
            switch(value){
                case ESupportTicketProduct.Other:
                    localized = __("Other");
                    break;
                default:
                    localized = key.replace(/([A-Z])/gm, " $1").trim();
                    break;
            }
            result[value] = {
                localized,
                licenseHelpArticle,
                key,
                value,
                ecommercePlatform,
                knowledgeBaseTopics
            };
        });
        return result;
    }, []);
}
export { useSupportFormProductType };
